const collector = 'https://apm.hexin.cn/skywalking-web';
const service = 'b2b::b2b-zx-broker-h5-page-container'; // 部门标识::业务树 （业务树取容器的‘发布单元名称”）
export const registerSky = function () {
  if (!window?.ClientMonitor) {
    return;
  }
  try {
    window.ClientMonitor.register({
      collector,
      rate: 0.01,
      service,
      pagePath: location.pathname,
      serviceVersion: 'newsDetail_1.0.2',
      enableSPA: false,
      useFmp: true,
      noTrace: true
    });
  } catch (e) {
    console.warn(e.message);
  }
};

export const reportErrors = function (error) {
  if (!window?.ClientMonitor) {
    return;
  }
  try {
    window.ClientMonitor.reportFrameErrors(
      {
        collector,
        service,
        pagePath: location.pathname,
        serviceVersion: 'newsDetail_1.0.2', // 版本，格式：业务标识_版本标识
      },
      error
    );
  } catch (e) {
    console.warn(e.message);
  }
};
